import { STORAGE } from "@constants/Storage";
import { PATHS } from "@constants/Paths";
export const getUserContext = () => {
    let userContext = null;
    try {
        const userDetailsString = sessionStorage.getItem(STORAGE.USER_CONTEXT);
        userContext = (userDetailsString && JSON.parse(userDetailsString)) || null;
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
    return userContext;
};
export const storeUserContext = (useContext) => {
    try {
        sessionStorage.setItem(STORAGE.USER_CONTEXT, JSON.stringify(useContext));
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
};
export const isAdminUser = (userContext) => {
    var _a;
    if (userContext) {
        return ((_a = userContext === null || userContext === void 0 ? void 0 : userContext.user) === null || _a === void 0 ? void 0 : _a.roleAlias) === "admin";
    }
    return false;
};
export const getRedirectPathAfterLogin = (user) => {
    return (user === null || user === void 0 ? void 0 : user.roleAlias) === "admin" ? PATHS.ADMIN_DASHBOARD : PATHS.HOME;
};
